
module.exports = {
    hintText: {
        zh: '系统不支持该浏览器，请使用最新版本 chrome 浏览器访问。',
        en: 'This browser is not supported. Please use the lastest Chrome browser instead.',
        ja: 'システムはこのブラウザをサポートしていません。アクセスするには最新バージョンの Chrome ブラウザを使用してください。'
    },
    language: 'zh',
    browserList: [ 'chrome' ],
    browserVersionMap: {
        chrome: "78"
    },
    ignoreMobile: true,
    remindInterval: 0,
    baseIndex: 10000,
}
